<template>
    <v-card elevation="2" height="100%">
        <v-card-text>
            <h2 class="display-1 mb-4">{{ title }}</h2>
            <v-flex>
                <v-autocomplete
                    @click="maybeGetEmployees"
                    label="Employee"
                    :items="selectableEmployees"
                    item-text="name"
                    item-value="id"
                    v-model="selectedEmployeeID"
                    :loading="apiCallPending"
                    :disabled="apiCallPending"
                    clearable
                ></v-autocomplete>
            </v-flex>
        </v-card-text>
        <v-card-actions>
            <v-layout justify-end>
                <v-btn :disabled="apiCallPending || !selectedEmployeeID" @click="getHours" color="primary"> Get {{ title }} </v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
import collectionApi from "@/api/collections";

export default {
    components: {},
    computed: {},
    created() {
        this.maybeGetEmployees();
    },
    props: ["title"],
    watch: {},
    data: function () {
        return {
            selectableEmployees: [],
            selectedEmployeeID: null,
            apiCallPending: false,
        };
    },
    computed: {},
    methods: {
        maybeGetEmployees() {
            if (this.selectableEmployees.length === 0) {
                this.apiCallPending = true;
                collectionApi.getEmployees((employees) => {
                    this.selectableEmployees = employees;
                    this.apiCallPending = false;
                });
            }
        },

        getHours: function () {
            this.$router.push({
                name: "employeeHours",
                query: {
                    employeeID: this.selectedEmployeeID,
                    period: "Total",
                },
            });
        },

        dateFormatted: function (date) {
            return date ? this.$moment(date).format("dddd, MMMM D") : "";
        },
    },
};
</script>
